/* eslint-disable import/prefer-default-export */
import { languagesRouteParam, getUrlLocale } from "config/languages";

export const webCheckInPath = {
  path: `${languagesRouteParam}/check-in`,
  to: ({ locale = "en" } = {}) => `/${getUrlLocale(locale)}check-in`,
  getPageTitle: () => "Check In",
  htmlBodyClassName: "view-sign-in_2018__landing-page web-checkin",
};
